<template>
  <m-input-select
    :label="label"
    :help-danger="helpDanger"
    :loading="jurisdictionsMeta.loading"
    :options="jurisdictions"
    :value="selectValue"
    @input="handleJurisdictionSelect"
  />
</template>

<script>
  import { MInputSelect } from 'codefabrik-gui-vue'
  import { masterDataService } from '@/services'
  import { useQuery } from 'codefabrik-gui-vue/src/apollo'

  export default {
    name: 'JurisdictionSelect',
    components: { MInputSelect },
    props: {
      label: {
        type: String,
        default: ''
      },
      value: {
        type: Object,
        default: null
      },
      helpDanger: {
        type: String,
        default: null
      },
    },
    computed: {
      selectValue() {
        return this.value.id;
      }
    },
    mixins: [
      useQuery({
        name: 'jurisdictions',
        serviceFn: masterDataService.getJurisdictions,
        mappingFunctions: {
          jurisdictions: [(jurisdictionData) => jurisdictionData.jurisdictions.map(jurisdiction => {
            return {
              label: jurisdiction.key,
              value: jurisdiction.id,
            }
          }), () => []],
        },
      })
    ],
    methods: {
      handleJurisdictionSelect (newValue) {
        this.$emit('input', {id: newValue})
      }
    }
  }
</script>

<style scoped>

</style>
